<!-- <div class="layout">
    <div id="chart-container"></div>
</div> -->
<!-- <div class="layout">
    <div id="chart-container"></div>
</div> -->
<!-- 
<div class="layout">
  <div id="chart-container{{id}}"></div>
</div> -->

<div style="display: flex; flex-direction: column; height: 100%; width: 100%;">
  <!-- Multi-cohort view -->
  <div *ngIf="isMultiCohort" style="display: flex; flex-direction: column; height: 100%; width: 100%;">
    <div class="multi-cohort-container">
      <div *ngFor="let cohort of cohorts; let i = index" class="cohort-chart-wrapper">
        <div class="cohort-title">
          {{ cohort.title }}
        </div>
        <div
          [id]="'chart-container' + id + '-' + i"
          [ngStyle]="{
            height: containerHeight,
            width: '100%',
            flex: '1 1 auto'
          }"
        ></div>
      </div>
    </div>
    <div *ngIf="isMultiCohort && popUp" id="shared-legend-container" style="width: 100%; display: flex; justify-content: center; margin-top: 0.5rem;"></div>
  </div>

  <!-- Multi-brand view -->
  <div *ngIf="isMultiBrand" style="display: flex; flex-direction: column; height: 100%; width: 100%;">
    <div class="multi-cohort-container">
      <div *ngFor="let brand of brands; let i = index" class="cohort-chart-wrapper">
        <div class="cohort-title">
          {{ brand.title }}
        </div>
        <div
          [id]="'chart-container' + id + '-brand-' + i"
          [ngStyle]="{
            height: containerHeight,
            width: '100%',
            flex: '1 1 auto'
          }"
        ></div>
      </div>
    </div>
    <!-- Shared legend for multi-brand (popup only) -->
    <div *ngIf="isMultiBrand && popUp" id="shared-legend-container" style="width: 100%; display: flex; justify-content: center; margin-top: 0.5rem;"></div>
  </div>

  <!-- Single chart view -->
  <div *ngIf="!isMultiCohort && !isMultiBrand"
    [ngStyle]="{
      height: containerHeight,
      width: '100%',
      flex: '1 1 auto'
    }"
  >
    <div
      [id]="'chart-container' + id"
      [ngStyle]="{
        height: chartHeight,
        width: '100%'
      }"
    ></div>
  </div>

  <ng-content select=".insights, [insights]"></ng-content>
</div>